import React from "react";
import { Link } from "react-router-dom";
const Navbar = ({ toggleNav, navOpen }) => {
	return (
		<nav>
			<div className="title">
				<Link to="/">SATENDRA</Link>
			</div>
			<div className="links">
				<p className="mobile_tap" onClick={toggleNav}>
					{navOpen ? <span>&#9587;</span> : <span>&#9776;</span>}
				</p>
				{/*<p className="mobile_tap">&#9587;</p>*/}
			</div>
		</nav>
	);
};

export default Navbar;
